export const MIN_BID_RATIO = 1  // %
export const MAX_BID_RATIO = 10 //%